import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import styles from './MenuButton.module.scss';

const EXTERNAL_MENU_ARROW_ICON = new URL('../../../../theme/assets/icons/external_link.svg', import.meta.url).href;

type Props = {
  label?: string;
  to?: string;
  onClick?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  tabIndex?: number;
  active?: boolean;
  startIcon?: React.ReactElement;
  endIcon?: boolean;
  small?: boolean;
  target?: string;
  rel?: string;
} & React.AriaAttributes;

const MenuButton: React.FC<Props> = ({
  label,
  to,
  onClick,
  onBlur,
  onFocus,
  tabIndex = 0,
  active = false,
  startIcon,
  endIcon = false,
  small = false,
  target='_blank',
  rel='noreferrer',
  ...rest
}: Props) => {
  const icon = startIcon ? <div className={styles.startIcon}>{startIcon}</div> : null;
  const endIconElement = endIcon ? (
    <div className={styles.endIcon}>
      <img src={EXTERNAL_MENU_ARROW_ICON} alt="" aria-hidden="true" />
    </div>
  ) : null;
  const getClassName = (isActive: boolean) => classNames(styles.menuButton, { [styles.small]: small }, { [styles.active]: isActive });

  // if (to) {
  //   return (
  //     <NavLink
  //       onBlur={onBlur}
  //       onFocus={onFocus}
  //       onClick={onClick}
  //       className={({ isActive }) => getClassName(isActive || active)}
  //       to={to}
  //       tabIndex={tabIndex}
  //       end
  //     >
  //       {icon}
  //       <span className={styles.label}>{label}</span>
  //       {endIconElement}
  //     </NavLink>
  //   );
  // }

  const isExternal = to && /^https?:\/\//.test(to);

  if (to) {
    if (isExternal) {
      return (
        <a href={to} target={target} rel={'noreferrer'}  className={getClassName(active)} {...rest}>
          {label}
          {endIconElement}
        </a>
      );
    }
    return (
      <NavLink className={({ isActive }) => getClassName(isActive || active)} to={to} {...rest}  end>
        {label}
      </NavLink>
    );
  }


  return (
    <div role="button" onBlur={onBlur} onFocus={onFocus} className={getClassName(active)} onClick={onClick} tabIndex={tabIndex} {...rest}>
      {icon}
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default MenuButton;
